import ClusterHubPage from '../../components/ClusterHubPage';
import { CLUSTERS } from '../../data/clusterConfig';
export default function UykuTestleriHub() {
  return <ClusterHubPage cluster={CLUSTERS['uyku-testleri']} />;
}
